import Vue from 'vue'
import { get } from '@/api'

export default {
  namespaced: true,
  state: {
    restaurants: null,
    content: {}
  },
  mutations: {
    SET_RESTAURANTS(state, restaurants) {
      state.restaurants = restaurants
    },

    SET_CONTENT(state, { content, posId }) {
      Vue.set(state.content, posId, content)
    }
  },
  actions: {
    async FETCH_ALL({ commit, state }) {
      if (state.restaurants) {
        return state.restaurants
      }
      try {
        const json = await get('restaurants')
        const data = json.data.restaurants.data.filter(restaurant => restaurant.is_public !== false)
        commit('SET_RESTAURANTS', data)
        return json.data.restaurants.data
      } catch (error) {
        throw error
      }
    },

    async FETCH_CONTENT({ commit }, posId) {
      try {
        const json = await get(`restaurants/${posId}/elements`)
        const content = json.data.elements
        commit('SET_CONTENT', { posId, content })
        return content
      } catch (error) {
        throw error
      }
    }
  },
  getters: {}
}
